import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { ItemStockReportViewModel } from 'src/app/viewmodels/g-item/ItemStockReportViewModel';
import { StockAdjustmentViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StockAdjustmentDetailViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentDetailViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { G_Warehouse_Viewmodel } from 'src/app/viewmodels/g-settings/G_Warehouse_Viewmodel';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SaveStockAdjustmentRequest, StockAdjustmentDetailModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
@Component({
  selector: 'app-stock-adjustment',
  templateUrl: './stock-adjustment.component.html',
  styleUrls: ['./stock-adjustment.component.scss']
})
export class StockAdjustmentComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  public modalRef: BsModalRef;
  public itemVm: ItemStockReportViewModel = new ItemStockReportViewModel();
  public vmS: SaveStockAdjustmentRequest;
  public vmD: StockAdjustmentDetailModel = new StockAdjustmentDetailModel();
  public vmListItems: any = [];
  public wareH: ItemViewModel1 = new ItemViewModel1();
  p: number = 1;
  public component_Title = 'Stock Adjustment';
  private submitted = false;
  public isDisable = false;
  public isSave = false;
  public isfetch = false;
  @Output() onSubmitted = new EventEmitter<any>();
  public nowDate: Date;
  public calingUrl: string;
  public urlId: number;
  public warehouseList: any = [];
  public selectedWarehouse: any = [];
  public user: any;

  public warehouseDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    debugger
    this.user = this._localStorageService.get("ussr");
    this.selectedWarehouse = [];
    if (this.vmS == undefined) {
      this.nowDate = new Date();
      this.vmS = new SaveStockAdjustmentRequest();
      this.vmS.id = 0;
      this.vmS.amount = 0;
      this.vmS.lastAmount = 0;
    }
    this.getGStockAdjustmentRefIdAsync();
    this.vmS.transactionDate = new Date();
    this.getWarehouses();
  }

  getGStockAdjustmentRefIdAsync() {
    debugger
    this._uow.gPurchaseService.GetGStockAdjustmentRefIdAsync().subscribe((res: any) => {
      debugger
      this.vmS.refId = res.code;
      console.log(res);
    }, (error) => {
      console.log(error);
    });
  }

  getWarehouses() {
    this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
      this.warehouseList = res.result;
      console.log(res);
    }, (error) => {
      console.log(error);
    });
  }

  onSelectWarehouse(e) {
    this.isfetch = true;
    // debugger
    // let f = this.warehouseList.find(x => x.Id == e.Id);
    // this.wareH = new G_Warehouse_Viewmodel();
    this.wareH.id = this.vmS.gWareHouse.id;
    this.wareH.name = this.vmS.gWareHouse.name;
    this.vmListItems = [];
    // this.selectedWarehouse.push(this.wareH);
    // this.getStockList();

  }


  onDeselectWarehouse(e) {
    this.selectedWarehouse = [];
  }

  getStockList() {
    this.spinner.show();
    this.vmD = new StockAdjustmentDetailModel();
    debugger
    let id = this.wareH.id;
    this._uow.gPurchaseService.GetStockAdjustmentByWarehouseIdAsync(id).subscribe((res: any) => {
      this.vmListItems = res.result;
      this.vmD = res.result;
      this.TotalStockAmount();
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();

    });
  }

  saveStockAdjustment() {
    debugger
    // this._jq.showSpinner(true);
    this.spinner.show();
    this.vmS.creditAccount = new ItemViewModel1(0, '');
    this.vmS.debitAccount = new ItemViewModel1(0, '');
    this.vmS.gWareHouse = new ItemViewModel1(this.wareH.id, this.wareH.name);
    //this.vmS = new StockAdjustmentViewModel();
    //this._uow.itemService.PostStockAdjustment(this.vmS).
    this._uow.gPurchaseService.SaveStockAdjustmentAsync(this.vmS).
      toPromise().then((res: any) => {
        console.log(res);
        this._jq.showSpinner();
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        this.getStockList();
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Added/Updated! Successfully',
          'success'
        )
        this.bsmRef.hide();
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        console.log(error);
        this.spinner.hide();
      });
  }

  public searchTerm = '';
  getBySearchTerm(e) {
    if (this.searchTerm !== ' ') {
      this._jq.showSpinner(true);
      this._uow.itemService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
        this.vmListItems = res.DtlList;
        this._jq.showSpinner();
      }, (error) => {
        console.log(error);
        this._jq.showSpinner();
      });
    }
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRefLv1.setClass('modal-lg');
  }

  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }

  StockChange(e) {
    debugger
    if (e.newQuantity != e.oldQuantity) {
      let diff = 0;
      let newAmount = e.costOfGoodSold * e.newQuantity;
      if (newAmount > e.newAmount) {
        diff = newAmount - e.newAmount;
        this.vmS.amount += diff;
      } else {
        diff = e.newAmount - newAmount;
        this.vmS.amount -= diff;
      }
      e.newAmount = e.costOfGoodSold * e.newQuantity;
      if (this.vmS.stockAdjustmentDetail == undefined) {
        this.vmS.stockAdjustmentDetail = [];
      }
      let stockDetail = this.vmS.stockAdjustmentDetail.find(x => x.item.id === e.item.id);
      if (stockDetail == undefined) {
        let stockadjustmentDetail = new StockAdjustmentDetailModel();
        stockadjustmentDetail.id = 0;
        stockadjustmentDetail.item = new ItemViewModel1(e.item.id, e.item.name);
        stockadjustmentDetail.newQuantity = e.newQuantity;
        stockadjustmentDetail.quantity = e.quantity;
        stockadjustmentDetail.oldQuantity = e.oldQuantity;
        stockadjustmentDetail.costOfGoodSold = e.costOfGoodSold;
        stockadjustmentDetail.newAmount = e.newAmount;
        stockadjustmentDetail.totalAmount = e.totalAmount;
        this.vmS.stockAdjustmentDetail.push(stockadjustmentDetail);
      } else {
        let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
        this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
        this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
      }
    }
    else {
      if (this.vmS.stockAdjustmentDetail != undefined) {
        let stockDetail = this.vmS.stockAdjustmentDetail.find(x => x.item.id === e.item.id);
        if (stockDetail != undefined) {
          let diff = 0;
          let newAmount = e.costOfGoodSold * e.newQuantity;
          if (newAmount > e.newAmount) {
            diff = newAmount - e.newAmount;
            this.vmS.amount += diff;
          } else {
            diff = e.newAmount - newAmount;
            this.vmS.amount -= diff;
          }
          e.newAmount = e.costOfGoodSold * e.newQuantity;
          let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
          this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
          this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
        }
      }
    }
    this.CheckStockAvailability(e);
  }

  CheckStockAvailability(e) {
    debugger
    if (e.newQuantity < e.oldQuantity) {
      let qtydif = e.oldQuantity - e.newQuantity;
      if (qtydif > e.quantity) {
        e.isDisable = true;
        this.isDisable = true;
      } else {
        e.isDisable = false;
        this.isDisable = false;
      }
    }
    this.vmS.stockAdjustmentDetail.forEach(x => {
      if (x.newQuantity < x.oldQuantity) {
        let qtydif = x.oldQuantity - x.newQuantity;
        if (qtydif > x.quantity) {
          x.isDisable = true;
          this.isDisable = true;
        } else {
          x.isDisable = false;
          this.isDisable = false;
        }
      }
    });
    let disableObject = this.vmS.stockAdjustmentDetail.find(x => x.isDisable == true);
    if (disableObject != undefined) {
      this.isDisable = true;
    } else {
      this.isDisable = false;
    }
  }

  TotalStockAmount() {
    this.vmS.amount = 0;
    this.vmS.lastAmount = 0;
    this.vmListItems.forEach(e => {
      this.vmS.amount += e.newAmount;
      this.vmS.lastAmount += e.totalAmount;
    });
  }

 public RemoveItem(e: any): void {
    // Find the index of the item you want to remove
    const index = this.vmListItems.findIndex(item => item.id === e.id);
    
    // If the item exists, remove it using slice
    if (index !== -1) {
        this.vmListItems = [
            ...this.vmListItems.slice(0, index), // Get items before the item to remove
            ...this.vmListItems.slice(index + 1) // Get items after the item to remove
        ];
    }

    this.TotalStockAmount();
}

blockInvalidKeys(event: KeyboardEvent) {
  const invalidKeys = ['-', 'e', 'E', '.', ','];
  if (invalidKeys.includes(event.key)) {
    event.preventDefault();
  }
}

}
